import { css } from 'styled-components'

import * as effects from '../constants/neue/effects'

export const shadowBox = css`
  box-shadow: ${effects.SHADOW_1};
`
